// @mui
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
// theme
import { hideScroll } from 'src/theme/css';
// hooks
import { useMockedUser } from 'src/hooks/use-mocked-user';
// components
import Logo from 'src/components/logo';
import { filterMenuPermissions, getPagesPermissions } from 'src/context/permission.context';
import { NavSectionMini } from 'src/components/nav-section';
//
import { useEffect, useState } from 'react';
import { NAV } from '../config-layout';
import { useNavData } from './config-navigation';
import { NavToggleButton } from '../_common';

// ----------------------------------------------------------------------

export default function NavMini() {
  const [backendRoutes, setBackendRoutes] = useState<any>();
  const { user } = useMockedUser();
  const navData = useNavData();
  const getData = async () => {
    try {
      const permissions = await getPagesPermissions();
      setBackendRoutes(permissions);
    } catch (error) {
      console.log(error.message);
    }
  }

  useEffect(() => {
    getData();
  }, []);

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV.W_MINI },
      }}
    >
      <NavToggleButton
        sx={{
          top: 22,
          left: NAV.W_MINI - 12,
        }}
      />

      <Stack
        sx={{
          pb: 2,
          height: 1,
          position: 'fixed',
          width: NAV.W_MINI,
          borderRight: (theme) => `dashed 1px ${theme.palette.divider}`,
          ...hideScroll.x,
        }}
      >
        <Logo sx={{ mx: 'auto', my: 2 }} />
        {!!backendRoutes && (
          <NavSectionMini
            data={filterMenuPermissions(navData, backendRoutes)}
            config={{
              currentRole: user?.role || 'admin',
            }}
          />
        )}
      </Stack>
    </Box>
  );
}
